import blocks from './blocks';
import components from './components';

export default (editor, config, currentMode, dispatch, templateId1) => {
  blocks(editor, config, currentMode);
  components(editor, config, dispatch, templateId1);
};
